import * as React from 'react'

function SvgMasterCardIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={34} height={24} rx={2.4} fill="#FAFAFA" />
      <g
        clipPath="url(#MasterCardIcon_svg__clip0)"
        fillRule="evenodd"
        clipRule="evenodd"
      >
        <path
          d="M17.048 17.166a6.469 6.469 0 01-4.244 1.583c-3.614 0-6.543-2.967-6.543-6.627 0-3.66 2.93-6.627 6.543-6.627 1.62 0 3.102.596 4.244 1.583a6.469 6.469 0 014.245-1.583c3.613 0 6.543 2.967 6.543 6.627 0 3.66-2.93 6.627-6.543 6.627a6.469 6.469 0 01-4.245-1.583z"
          fill="#FF5E00"
        />
        <path
          d="M17.048 17.166a6.469 6.469 0 01-4.244 1.583c-3.614 0-6.543-2.967-6.543-6.627 0-3.66 2.93-6.627 6.543-6.627 1.62 0 3.102.596 4.244 1.583a6.647 6.647 0 00-2.298 5.044c0 2.02.892 3.828 2.298 5.044z"
          fill="#ED0006"
        />
        <path
          d="M17.048 17.166a6.469 6.469 0 004.244 1.583c3.614 0 6.543-2.967 6.543-6.627 0-3.66-2.93-6.627-6.543-6.627-1.62 0-3.102.596-4.244 1.583a6.647 6.647 0 012.299 5.044c0 2.02-.892 3.828-2.3 5.044z"
          fill="#F9A000"
        />
      </g>
      <defs>
        <clipPath id="MasterCardIcon_svg__clip0">
          <path
            fill="#fff"
            transform="translate(6.084 5.373)"
            d="M0 0h22.343v13.44H0z"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgMasterCardIcon
